"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cerrina-monferrato": {
    "2b4b9231": [{
      "hkey": "08cc2bff",
      "slug": "rosingo",
      "name": "Rosingo",
      "primary": true,
      "skipSearch": false
    }],
    "montaldo-rosinso": [{
      "hkey": "08cc2bff",
      "slug": "rosingo",
      "name": "Rosingo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "53c30278": [{
      "hkey": "274070e1",
      "slug": "valle-cerrina",
      "name": "Valle Cerrina",
      "primary": true,
      "skipSearch": false
    }],
    "valle": [{
      "hkey": "274070e1",
      "slug": "valle-cerrina",
      "name": "Valle Cerrina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;